import _ from '@/utils/lodash-optimized'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { withLegacyRouter } from '../../../../../decorators'
import { map, unmap } from '../../../../../lib/Proxy/insurance'
import { IGAO } from '../../../../igao'
import * as Card from '../../../../shared/card'
import CrudTable from '../../../../shared/CrudTable'
import ConfirmationDeleteDialog from '../../../../shared/DeleteDialog/ConfirmationDeleteDialog'

import { insuranceIssueCheck, getInsurance } from './actions'
import Insurance from './components/insurance'

const formatPhoneNumber = number => {
  if (_.isNil(number)) {
    return
  }
  const trimmed = value => value.replace(/\D/g, '')
  const first10 = value => value.substr(0, 10)
  const formatted = value =>
    value.replace(/^(\d{3})(\d{3})(\d{4}).*/, '$1.$2.$3')
  return formatted(first10(trimmed(number)))
}

const mkSpec = patientId => ({
  type: 'insurance',
  form: Insurance,
  urls: {
    get: () => `/patients/${patientId}/insurance`,
    create: () => `/patients/${patientId}/insurance`,
    update: entry => `/patients/${patientId}/insurance/${entry.id}`,
    delete: entry => `/patients/${patientId}/insurance/${entry.id}`
  },
  mapFns: {
    toForm: entry => (entry.resource ? unmap(entry.resource) : unmap(entry)),
    toFhir: entry => map(patientId, entry)
  },
  table: [
    {
      title: 'Carrier',
      displayFn: x => x.provider
    },
    {
      title: 'Subscriber Name',
      displayFn: x => x.subscriberName
    },
    {
      title: 'Subscriber ID',
      displayFn: x => x.subscriberNumber
    },
    {
      title: 'Phone',
        displayFn: x => formatPhoneNumber(x?.phoneNumber)
    },
    {
      title: 'Type',
        displayFn: x => x?.primaryOrSecondary
    }
  ]
})

class InsuranceGrid extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      open: true
    }
  }

  componentWillUnmount () {
    const { insurance, dispatch } = this.props
    if (!insurance.items) {
      dispatch(insuranceIssueCheck())
    }
  }

  render () {
    const {
      params,
      patientId: propPatientId,
      dispatch
    } = this.props
    const patientId = params ? params.id : propPatientId
    const spec = mkSpec(patientId)

    return (
      <div className='main'>
        <Card.Card expandable>
          <Card.Header>
            <h2>Insurance Carriers</h2>
          </Card.Header>
          <Card.ExpandableWrapper style={{ padding: '0 1rem 1rem 1rem' }}>
            <CrudTable
              labelButton='Insurance'
              labelNoEntries='Insurance Carriers'
              urlFns={spec.urls}
              entryType={spec.type}
              entrySet={patientId}
              tableDefinition={spec.table}
              mapFns={spec.mapFns}
              form={spec.form}
              deleteDialog={ConfirmationDeleteDialog}
              callbackFn={() => {
                dispatch(getInsurance(params.id))
              }}
            />
          </Card.ExpandableWrapper>
        </Card.Card>
        <IGAO path='insurances' />
      </div>
    )
  }
}

InsuranceGrid.contextTypes = {
  dispatch: PropTypes.instanceOf(Object)
}

const mapStateToProps = redux => {
  const patientId = redux?.globalVars?.params?.id
  const insurance = redux?.insurance
  return {
    insurance,
    patientId
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(withLegacyRouter(InsuranceGrid))
